module.exports = __webpack_public_path__ + "img/404.bdbc70a8.png";